import { PAGE_KEY } from '@/constants/state'
import { useVaultsSearchState } from '@/hooks/useVaultsSearchState'
import { ListPagination } from '../common/listPagination'

interface VaultsPaginationProps {
  currentPage: number
  itemsCount: number
  itemsPerPage: number
  className?: string
}
export const VaultsPagination = ({ currentPage, itemsCount, itemsPerPage, className }: VaultsPaginationProps) => {
  const { updateSearchState } = useVaultsSearchState()

  return (
    <ListPagination
      currentPage={currentPage}
      itemsCount={itemsCount}
      itemsPerPage={itemsPerPage}
      onPageChange={(page) => updateSearchState([PAGE_KEY, page])}
      className={className}
    />
  )
}
